import { useEffect, useState } from "react";
import { FileText, Download, Eye, Lock } from "lucide-react";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5001/api";

import "./SharePage.css";

function downloadFile(url, filename) {
    fetch(url)
        .then((res) => res.blob())
        .then((blob) => {
            const a = document.createElement("a");
            const objectUrl = URL.createObjectURL(blob);
            a.href = objectUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(objectUrl);
        });
}

export default function SharePage() {
    const token = window.location.pathname.split("/share/")[1];
    const [status, setStatus] = useState("loading");
    const [fileInfo, setFileInfo] = useState(null);

    useEffect(() => {
        if (!token) {
            setStatus("invalid");
            return;
        }
        fetch(`${API_URL}/files/share/${token}/info`)
            .then((res) => (res.ok ? res.json() : Promise.reject()))
            .then((data) => {
                setFileInfo(data);
                setStatus("valid");
            })
            .catch(() => setStatus("invalid"));
    }, [token]);

    const fileUrl = `${API_URL}/files/share/${token}`;

    if (status === "loading")
        return (
            <div className="share-page">
                <div className="share-card">
                    <div className="share-page-icon">
                        <FileText size={56} />
                    </div>
                    <h2>Checking link…</h2>
                    <p>Just a moment.</p>
                </div>
            </div>
        );

    if (status === "invalid")
        return (
            <div className="share-page">
                <div className="share-card">
                    <div
                        className="share-page-icon"
                        style={{ color: "var(--border-dk)" }}
                    >
                        <Lock size={56} />
                    </div>
                    <h2>File not found</h2>
                    <p>
                        This link may have expired, been revoked, or never
                        existed.
                    </p>
                </div>
            </div>
        );

    return (
        <div className="share-page">
            <div className="share-card">
                <div className="share-page-icon">
                    <FileText size={56} />
                </div>
                <h2>{fileInfo.name}</h2>
                <p>You've been given access to this file.</p>
                <button
                    className="download-btn"
                    onClick={() => downloadFile(fileUrl, fileInfo.name)}
                >
                    <Download
                        size={16}
                        style={{
                            display: "inline",
                            marginRight: 8,
                            verticalAlign: "middle",
                        }}
                    />
                    Download File
                </button>
                <a
                    href={fileUrl}
                    className="view-btn"
                    target="_blank"
                    rel="noreferrer"
                >
                    <Eye
                        size={16}
                        style={{
                            display: "inline",
                            marginRight: 8,
                            verticalAlign: "middle",
                        }}
                    />
                    View in Browser
                </a>
            </div>
        </div>
    );
}
